/* ────────────────────────────────────────────────────────────────────────── */
/*  Constants & data layer                                                    */
/* ────────────────────────────────────────────────────────────────────────── */

const FITNESS_STORE = 'xceller_fitness_v2';
const LEGACY_STORE = 'xceller_fitness_v1';
export const THEME_KEY = 'xceller_theme';
const WORKOUT_DAY_ROLLOVER_HOUR = 4;

export const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const MUSCLE_GROUPS = ['Chest', 'Back', 'Shoulders', 'Biceps', 'Triceps', 'Forearms', 'Quads', 'Hamstrings', 'Glutes', 'Calves', 'Core', 'Cardio'];

export const EXERCISE_LIBRARY = [
  // Chest
  { name: 'Flat Barbell Bench Press', muscle: 'Chest', equipment: 'barbell' },
  { name: 'Incline Barbell Bench Press', muscle: 'Chest', equipment: 'barbell' },
  { name: 'Decline Barbell Bench Press', muscle: 'Chest', equipment: 'barbell' },
  { name: 'Flat Dumbbell Press', muscle: 'Chest', equipment: 'dumbbell' },
  { name: 'Incline Dumbbell Press', muscle: 'Chest', equipment: 'dumbbell' },
  { name: 'Decline Dumbbell Press', muscle: 'Chest', equipment: 'dumbbell' },
  { name: 'Smith Machine Bench Press', muscle: 'Chest', equipment: 'machine' },
  { name: 'Machine Chest Press', muscle: 'Chest', equipment: 'machine' },
  { name: 'Machine Chest Fly', muscle: 'Chest', equipment: 'machine' },
  { name: 'Cable Fly', muscle: 'Chest', equipment: 'cable' },
  { name: 'Cable Crossover (high)', muscle: 'Chest', equipment: 'cable' },
  { name: 'Cable Crossover (low)', muscle: 'Chest', equipment: 'cable' },
  { name: 'Pec Deck', muscle: 'Chest', equipment: 'machine' },
  { name: 'Push-up', muscle: 'Chest', equipment: 'bodyweight' },
  { name: 'Decline Push-up', muscle: 'Chest', equipment: 'bodyweight' },
  { name: 'Chest Dip', muscle: 'Chest', equipment: 'bodyweight' },
  { name: 'Assisted Chest Dip (machine)', muscle: 'Chest', equipment: 'machine' },
  { name: 'Svend Press', muscle: 'Chest', equipment: 'plate' },

  // Back
  { name: 'Conventional Deadlift', muscle: 'Back', equipment: 'barbell' },
  { name: 'Sumo Deadlift', muscle: 'Back', equipment: 'barbell' },
  { name: 'Trap Bar Deadlift', muscle: 'Back', equipment: 'barbell' },
  { name: 'Pull-up', muscle: 'Back', equipment: 'bodyweight' },
  { name: 'Chin-up', muscle: 'Back', equipment: 'bodyweight' },
  { name: 'Assisted Pull-ups (machine)', muscle: 'Back', equipment: 'machine' },
  { name: 'Lat Pulldown (wide grip)', muscle: 'Back', equipment: 'cable' },
  { name: 'Lat Pulldown (close grip)', muscle: 'Back', equipment: 'cable' },
  { name: 'Lat Pulldown (neutral grip)', muscle: 'Back', equipment: 'cable' },
  { name: 'Barbell Row (overhand)', muscle: 'Back', equipment: 'barbell' },
  { name: 'Barbell Row (underhand)', muscle: 'Back', equipment: 'barbell' },
  { name: 'Pendlay Row', muscle: 'Back', equipment: 'barbell' },
  { name: 'T-Bar Row', muscle: 'Back', equipment: 'barbell' },
  { name: 'Dumbbell Row (1 arm)', muscle: 'Back', equipment: 'dumbbell' },
  { name: 'Chest Supported Row', muscle: 'Back', equipment: 'machine' },
  { name: 'Diverging Seated Row', muscle: 'Back', equipment: 'machine' },
  { name: 'Cable Row (close grip)', muscle: 'Back', equipment: 'cable' },
  { name: 'Cable Row (wide grip)', muscle: 'Back', equipment: 'cable' },
  { name: 'Inverted Row', muscle: 'Back', equipment: 'bodyweight' },
  { name: 'Straight-arm Pulldown', muscle: 'Back', equipment: 'cable' },
  { name: 'Face Pull', muscle: 'Back', equipment: 'cable' },
  { name: 'Shrugs (barbell)', muscle: 'Back', equipment: 'barbell' },
  { name: 'Shrugs (dumbbell)', muscle: 'Back', equipment: 'dumbbell' },
  { name: 'Reverse Pec Deck', muscle: 'Back', equipment: 'machine' },

  // Shoulders
  { name: 'Overhead Press (standing)', muscle: 'Shoulders', equipment: 'barbell' },
  { name: 'Overhead Press (seated)', muscle: 'Shoulders', equipment: 'barbell' },
  { name: 'Dumbbell Shoulder Press', muscle: 'Shoulders', equipment: 'dumbbell' },
  { name: 'Arnold Press', muscle: 'Shoulders', equipment: 'dumbbell' },
  { name: 'Machine Shoulder Press', muscle: 'Shoulders', equipment: 'machine' },
  { name: 'Lateral Raises', muscle: 'Shoulders', equipment: 'dumbbell' },
  { name: 'Cable Lateral Raise', muscle: 'Shoulders', equipment: 'cable' },
  { name: 'Machine Lateral Raise', muscle: 'Shoulders', equipment: 'machine' },
  { name: 'Front Raise (dumbbell)', muscle: 'Shoulders', equipment: 'dumbbell' },
  { name: 'Front Raise (cable)', muscle: 'Shoulders', equipment: 'cable' },
  { name: 'Rear Delt Fly (dumbbell)', muscle: 'Shoulders', equipment: 'dumbbell' },
  { name: 'Rear Delt Cable Fly', muscle: 'Shoulders', equipment: 'cable' },
  { name: 'Upright Row', muscle: 'Shoulders', equipment: 'barbell' },
  { name: 'Cuban Press', muscle: 'Shoulders', equipment: 'dumbbell' },

  // Biceps
  { name: 'Barbell Curl', muscle: 'Biceps', equipment: 'barbell' },
  { name: 'EZ-bar Curl', muscle: 'Biceps', equipment: 'barbell' },
  { name: 'Dumbbell Curl', muscle: 'Biceps', equipment: 'dumbbell' },
  { name: 'Hammer Curl', muscle: 'Biceps', equipment: 'dumbbell' },
  { name: 'Incline Dumbbell Curl', muscle: 'Biceps', equipment: 'dumbbell' },
  { name: 'Concentration Curl', muscle: 'Biceps', equipment: 'dumbbell' },
  { name: 'Spider Curl', muscle: 'Biceps', equipment: 'dumbbell' },
  { name: 'Preacher Curl (barbell)', muscle: 'Biceps', equipment: 'barbell' },
  { name: 'Preacher Curl (machine, per arm)', muscle: 'Biceps', equipment: 'machine' },
  { name: 'Cable Curl (bar)', muscle: 'Biceps', equipment: 'cable' },
  { name: 'Cable Curl (rope)', muscle: 'Biceps', equipment: 'cable' },
  { name: 'Cross-body Hammer Curl', muscle: 'Biceps', equipment: 'dumbbell' },

  // Forearms
  { name: 'Reverse Curls', muscle: 'Forearms', equipment: 'barbell' },
  { name: 'Cable Curls', muscle: 'Forearms', equipment: 'cable' },
  { name: 'Wrist Curls', muscle: 'Forearms', equipment: 'dumbbell' },

  // Triceps
  { name: 'Tricep Pushdown (cable)', muscle: 'Triceps', equipment: 'cable' },
  { name: 'Tricep Pushdown (rope)', muscle: 'Triceps', equipment: 'cable' },
  { name: 'Skull Crushers', muscle: 'Triceps', equipment: 'barbell' },
  { name: 'Overhead Tricep Extension (cable)', muscle: 'Triceps', equipment: 'cable' },
  { name: 'Overhead Tricep Extension (dumbbell)', muscle: 'Triceps', equipment: 'dumbbell' },
  { name: 'Close-Grip Bench Press', muscle: 'Triceps', equipment: 'barbell' },
  { name: 'JM Press', muscle: 'Triceps', equipment: 'barbell' },
  { name: 'Tricep Dip', muscle: 'Triceps', equipment: 'bodyweight' },
  { name: 'Tricep Kickback', muscle: 'Triceps', equipment: 'dumbbell' },
  { name: 'Diamond Push-up', muscle: 'Triceps', equipment: 'bodyweight' },
  { name: 'Machine Tricep Extension', muscle: 'Triceps', equipment: 'machine' },

  // Quads
  { name: 'Back Squat', muscle: 'Quads', equipment: 'barbell' },
  { name: 'Front Squat', muscle: 'Quads', equipment: 'barbell' },
  { name: 'High-Bar Squat', muscle: 'Quads', equipment: 'barbell' },
  { name: 'Goblet Squat (dumbbell)', muscle: 'Quads', equipment: 'dumbbell' },
  { name: 'Hack Squat (machine)', muscle: 'Quads', equipment: 'machine' },
  { name: 'Leg Press', muscle: 'Quads', equipment: 'machine' },
  { name: 'Leg Press (high stance)', muscle: 'Quads', equipment: 'machine' },
  { name: 'Leg Extension', muscle: 'Quads', equipment: 'machine' },
  { name: 'Bulgarian Split Squat', muscle: 'Quads', equipment: 'dumbbell' },
  { name: 'Walking Lunge', muscle: 'Quads', equipment: 'dumbbell' },
  { name: 'Reverse Lunge', muscle: 'Quads', equipment: 'dumbbell' },
  { name: 'Step-up', muscle: 'Quads', equipment: 'dumbbell' },
  { name: 'Sissy Squat', muscle: 'Quads', equipment: 'bodyweight' },
  { name: 'Pistol Squat', muscle: 'Quads', equipment: 'bodyweight' },

  // Hamstrings
  { name: 'Romanian Deadlift', muscle: 'Hamstrings', equipment: 'barbell' },
  { name: 'Romanian Deadlift (dumbbell)', muscle: 'Hamstrings', equipment: 'dumbbell' },
  { name: 'Stiff-Leg Deadlift', muscle: 'Hamstrings', equipment: 'barbell' },
  { name: 'Single-Leg RDL', muscle: 'Hamstrings', equipment: 'dumbbell' },
  { name: 'Leg Curl (lying machine)', muscle: 'Hamstrings', equipment: 'machine' },
  { name: 'Leg Curl (seated machine)', muscle: 'Hamstrings', equipment: 'machine' },
  { name: 'Leg Curl (standing)', muscle: 'Hamstrings', equipment: 'machine' },
  { name: 'Good Morning', muscle: 'Hamstrings', equipment: 'barbell' },
  { name: 'Nordic Curl', muscle: 'Hamstrings', equipment: 'bodyweight' },

  // Glutes
  { name: 'Hip Thrust', muscle: 'Glutes', equipment: 'barbell' },
  { name: 'Glute Bridge', muscle: 'Glutes', equipment: 'barbell' },
  { name: 'Cable Pull-through', muscle: 'Glutes', equipment: 'cable' },
  { name: 'Cable Glute Kickback', muscle: 'Glutes', equipment: 'cable' },
  { name: 'Bulgarian Split Squat (glute focus)', muscle: 'Glutes', equipment: 'dumbbell' },
  { name: 'Glute Ham Raise', muscle: 'Glutes', equipment: 'machine' },

  // Calves
  { name: 'Standing Calf Raise', muscle: 'Calves', equipment: 'machine' },
  { name: 'Seated Calf Raise', muscle: 'Calves', equipment: 'machine' },
  { name: 'Donkey Calf Raise', muscle: 'Calves', equipment: 'machine' },
  { name: 'Leg Press Calf Raise', muscle: 'Calves', equipment: 'machine' },
  { name: 'Calf Raises', muscle: 'Calves', equipment: 'bodyweight' },
  { name: 'Single-Leg Calf Raise', muscle: 'Calves', equipment: 'dumbbell' },

  // Core
  { name: 'Plank', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Side Plank', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Hanging Leg Raise', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Hanging Knee Raise', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Cable Crunch', muscle: 'Core', equipment: 'cable' },
  { name: 'Russian Twist', muscle: 'Core', equipment: 'plate' },
  { name: 'Ab Wheel Rollout', muscle: 'Core', equipment: 'wheel' },
  { name: 'Decline Sit-up', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Pallof Press', muscle: 'Core', equipment: 'cable' },
  { name: 'Dead Bug', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Bird Dog', muscle: 'Core', equipment: 'bodyweight' },
  { name: 'Wood Chop (cable)', muscle: 'Core', equipment: 'cable' },

  // Cardio
  { name: 'Treadmill Run', muscle: 'Cardio', equipment: 'machine' },
  { name: 'Treadmill Walk (incline)', muscle: 'Cardio', equipment: 'machine' },
  { name: 'Stationary Bike', muscle: 'Cardio', equipment: 'machine' },
  { name: 'Rowing Machine', muscle: 'Cardio', equipment: 'machine' },
  { name: 'Stair Climber', muscle: 'Cardio', equipment: 'machine' },
  { name: 'Elliptical', muscle: 'Cardio', equipment: 'machine' },
  { name: 'Jump Rope', muscle: 'Cardio', equipment: 'rope' },
  { name: 'Burpees', muscle: 'Cardio', equipment: 'bodyweight' },
];

/* Form cues. Keys are normalized substrings matched against exercise name (lowercase).
 * First matching entry wins. Order matters for specificity (more specific first). */
const EXERCISE_TIPS = {
  'romanian deadlift': [
    'Hinge at the hips, not the waist — push your butt back.',
    'Soft knees, not locked. Knee angle stays roughly constant.',
    'Bar/dumbbells stay close to your legs.',
    'Stretch in hamstrings is the cue, not depth.',
    'Drive hips forward to lock out — squeeze glutes.',
  ],
  'stiff-leg deadlift': [
    'Keep legs straighter than RDL; small knee bend only.',
    'Lower until you feel a deep hamstring stretch.',
    'Neutral spine — no rounding the lower back.',
  ],
  'sumo deadlift': [
    'Wide stance, toes pointed out ~30°.',
    'Bar over midfoot, arms inside knees.',
    'Push knees out as you drive up.',
  ],
  'deadlift': [
    'Bar over midfoot. Shoulders slightly in front of bar.',
    'Hips and shoulders rise at the same rate.',
    'Drag the bar up your shins — keep it close.',
    'Brace core hard before lifting; lock out by squeezing glutes.',
    'Reset between reps. Don\'t bounce.',
  ],
  'bench press': [
    'Tuck elbows ~45° from torso — never fully flared.',
    'Bar path: from mid-chest to slightly over shoulders.',
    'Drive feet into the floor — leg drive helps a lot.',
    'Shoulder blades retracted and pinned to the bench.',
    'Pause briefly on the chest, then press explosively.',
  ],
  'incline dumbbell press': [
    'Bench at ~30° — not too steep or it becomes shoulders.',
    'Lower dumbbells to upper chest, not shoulders.',
    'Keep wrists stacked over elbows.',
  ],
  'incline barbell bench press': [
    'Bench at ~30°. Steeper = more shoulders, less chest.',
    'Bar to upper chest. Slight arch in upper back.',
    'Don\'t bounce — pause briefly on chest.',
  ],
  'dumbbell press': [
    'Press dumbbells slightly inward at the top — squeeze chest.',
    'Lower until you feel a stretch, not full lockout below.',
    'Wrists straight, knuckles up.',
  ],
  'cable fly': [
    'Slight bend in elbows, locked throughout — no curling.',
    'Squeeze hands together at the front, hold 1 second.',
    'Stretch on the eccentric — let arms go slightly past torso.',
  ],
  'pec deck': [
    'Don\'t over-stretch — stop when you feel pec stretch, not shoulder.',
    'Squeeze hard at the contraction.',
    'Keep shoulders back and down, off the pad.',
  ],
  'push-up': [
    'Body straight from heels to head — no sagging hips.',
    'Lower until chest grazes the floor.',
    'Hands slightly wider than shoulders.',
  ],
  'chest dip': [
    'Lean forward ~30° to bias chest over triceps.',
    'Lower until upper arms are parallel to floor — don\'t go deeper.',
    'Keep shoulders down, away from ears.',
  ],
  'back squat': [
    'Brace core hard before each rep — full belly breath.',
    'Knees track over toes — don\'t cave inward.',
    'Sit back AND down, not just forward.',
    'Drive through midfoot/heels, chest up.',
    'Bar high or low on traps — pick one and stay consistent.',
  ],
  'front squat': [
    'Elbows high — don\'t let them drop or you lose the bar.',
    'Stay upright; don\'t lean forward like in back squat.',
    'Slightly narrower stance than back squat.',
  ],
  'goblet squat': [
    'Hold dumbbell against chest, elbows pointed down.',
    'Sit between your feet, elbows brushing inside knees.',
    'Drive through heels, chest tall.',
  ],
  'squat': [
    'Knees track over toes, no caving in.',
    'Brace core before each rep.',
    'Drive through midfoot/heels.',
  ],
  'leg press': [
    'Feet shoulder-width, mid-platform for balanced quad work.',
    'Higher feet = more hams/glutes; lower = more quads.',
    'Don\'t lock knees at the top.',
    'Lower until ~90° knee angle, no lower-back rounding.',
  ],
  'hack squat': [
    'Push through whole foot, not just toes.',
    'Knees can travel over toes — that\'s OK here.',
    'Lower under control to ~90°.',
  ],
  'bulgarian split squat': [
    'Most weight on the front leg (~80/20).',
    'Front shin slightly forward at the bottom.',
    'Keep torso mostly upright.',
    'Don\'t bounce off the rear knee.',
  ],
  'leg extension': [
    'Squeeze the quads at the top — pause 1 second.',
    'Don\'t swing or use momentum.',
    'Toes can point slightly out for outer quad emphasis.',
  ],
  'leg curl': [
    'Curl the heel toward the glute, not just any movement.',
    'Squeeze hard at the top.',
    'Keep hips pinned to the pad — no lifting.',
  ],
  'hip thrust': [
    'Squeeze glutes HARD at the top — chin tucked, ribs down.',
    'Don\'t hyperextend lower back to get more range.',
    'Feet flat, shins vertical at lockout.',
  ],
  'calf raise': [
    'Full range: deep stretch at the bottom, full squeeze at top.',
    'Pause 1 second at the top.',
    'Slow eccentric — lower for 2-3 seconds.',
  ],
  'overhead press': [
    'Bar starts at upper chest, not shoulders.',
    'Squeeze glutes and brace core — no lower-back arch.',
    'Push head through at lockout — bar over mid-foot.',
    'Elbows slightly in front of bar, not flared.',
  ],
  'shoulder press': [
    'Press straight up, not forward.',
    'Don\'t flare elbows fully — slight forward angle.',
    'Lower to ear level minimum, not just chin.',
  ],
  'arnold press': [
    'Start with palms facing you, end with palms forward.',
    'Smooth rotation through the full press.',
    'Don\'t lock elbows hard at top.',
  ],
  'lateral raise': [
    'Slight forward lean of upper body, elbows slightly bent.',
    'Lead with elbows, not hands.',
    'Stop at shoulder height — no higher.',
    'Pinky slightly higher than thumb at top.',
    'Slow on the way down.',
  ],
  'rear delt fly': [
    'Bend forward 45°+, chest up, neutral spine.',
    'Pull with elbows wide, not by squeezing shoulder blades.',
    'Light weight — form first.',
  ],
  'face pull': [
    'Pull rope toward your forehead, not chin.',
    'External rotation at the end — like a double biceps pose.',
    'Light weight, high reps. Don\'t ego lift.',
  ],
  'pull-up': [
    'Start from a dead hang — no bouncing.',
    'Drive elbows down and back, not pull with arms only.',
    'Chin clears the bar at the top.',
    'Lower under control (2-3 sec).',
  ],
  'chin-up': [
    'Underhand grip, shoulder-width.',
    'Drive elbows down to your sides.',
    'More biceps involvement than pull-up.',
  ],
  'lat pulldown': [
    'Lean back ~15-20°. Pull bar to upper chest.',
    'Drive elbows down and slightly back, not pull with biceps.',
    'Don\'t shrug — keep shoulders down.',
    'Pause at the bottom, slow on the way up.',
  ],
  'barbell row': [
    'Hinge to ~45°, neutral spine, knees soft.',
    'Pull bar to lower chest / upper abs.',
    'Lead with elbows, squeeze shoulder blades at top.',
    'Don\'t use momentum — strict form.',
  ],
  'dumbbell row': [
    'Hinge over flat bench, opposite hand and knee on bench.',
    'Pull dumbbell to your hip, elbow tight to body.',
    'Don\'t rotate the torso — stay square.',
  ],
  'cable row': [
    'Sit tall, slight forward lean at the start, upright at the pull.',
    'Pull handle to abdomen, elbows along your sides.',
    'Squeeze shoulder blades at the end.',
  ],
  't-bar row': [
    'Wide enough stance for clearance, hinge ~45°.',
    'Pull to lower chest, elbows out for upper back.',
    'Brace core to protect lower back.',
  ],
  'preacher curl': [
    'Don\'t fully lock out elbows at the bottom — keep tension.',
    'Slow eccentric — lower for 3 seconds.',
    'Squeeze biceps hard at the top.',
  ],
  'hammer curl': [
    'Neutral grip — palms facing each other.',
    'Don\'t swing hips or use momentum.',
    'Hits brachialis and forearm more than regular curl.',
  ],
  'barbell curl': [
    'Elbows pinned at sides — don\'t let them drift forward.',
    'Don\'t swing the torso.',
    'Squeeze at the top, control on the way down.',
  ],
  'dumbbell curl': [
    'Supinate the wrist as you curl (turn palm up).',
    'Elbows still — only forearm moves.',
    'Squeeze biceps hard at the top.',
  ],
  'cable curl': [
    'Constant tension — don\'t let the stack rest.',
    'Elbows pinned, only forearm moves.',
  ],
  'tricep pushdown': [
    'Elbows pinned to your sides — don\'t let them flare.',
    'Lock out fully at the bottom, squeeze 1 sec.',
    'Slow eccentric — control the weight back up.',
  ],
  'skull crusher': [
    'Elbows pointed at the ceiling, slightly forward.',
    'Lower bar/db to forehead or just past it.',
    'Don\'t flare elbows out wide.',
  ],
  'overhead tricep extension': [
    'Elbows close to head, not flared.',
    'Full stretch at the bottom — feel it in the long head.',
    'Lock out fully at the top.',
  ],
  'jm press': [
    'Use a shoulder-width grip and keep your upper arms angled slightly toward your head.',
    'Lower the bar toward your chin or upper chest by bending the elbows; do not turn it into a normal bench press.',
    'Keep the range short and controlled, then extend the elbows hard to finish with the triceps.',
    'Start light. Stop or change the bar path if your elbows or wrists hurt.',
  ],
  'close-grip bench': [
    'Grip ~shoulder-width, no narrower (wrists hate it).',
    'Elbows tucked tight throughout.',
    'Bar to lower chest.',
  ],
  'plank': [
    'Body straight from head to heels — no sagging or piking.',
    'Squeeze glutes and brace core.',
    'Breathe normally — don\'t hold breath.',
  ],
  'hanging leg raise': [
    'Don\'t swing — control the descent.',
    'Posterior pelvic tilt at the top — flatten lower back.',
    'Knees-up version is fine if you can\'t go full leg.',
  ],
  'cable crunch': [
    'Crunch from the abs, not by pulling with the arms.',
    'Curl your spine — bring elbows to thighs.',
    'Slow eccentric.',
  ],
  'russian twist': [
    'Lift feet off the floor for harder version.',
    'Rotate through the torso, not just the arms.',
    'Slow and controlled — quality over speed.',
  ],
  'ab wheel': [
    'Tuck pelvis (PPT) before rolling — keep lower back rounded slightly.',
    'Roll out to your limit, not until you collapse.',
    'Squeeze abs hard to roll back.',
  ],
};

export function getTipsForExercise(name) {
  const lower = (name || '').toLowerCase();
  if (!lower) return null;
  // Most specific first (longer key likely more specific)
  const keys = Object.keys(EXERCISE_TIPS).sort((a, b) => b.length - a.length);
  for (const k of keys) if (lower.includes(k)) return EXERCISE_TIPS[k];
  return null;
}

export const TYPE_COLORS = {
  push: '#ef4444',
  pull: '#3b82f6',
  legs: '#8b5cf6',
  rest: '#94a3b8',
  upper: '#f59e0b',
  lower: '#10b981',
  full: '#06b6d4',
};

export const MEAL_GROUPS = [
  { id: 'breakfast', label: 'Breakfast' },
  { id: 'lunch', label: 'Lunch' },
  { id: 'dinner', label: 'Dinner' },
  { id: 'snack', label: 'Snacks' },
];
export const DEFAULT_MEAL_GROUP = 'snack';

export const MACRO_META = [
  { key: 'kcal', label: 'Calories', unit: 'kcal', color: '#f59e0b' },
  { key: 'protein', label: 'Protein', unit: 'g', color: '#10b981' },
  { key: 'carbs', label: 'Carbs', unit: 'g', color: '#3b82f6' },
  { key: 'fats', label: 'Fats', unit: 'g', color: '#8b5cf6' },
];

export function uid(prefix) { return `${prefix}-${Math.random().toString(36).slice(2, 9)}`; }

export function dateKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
export function workoutToday() {
  const d = new Date();
  if (d.getHours() < WORKOUT_DAY_ROLLOVER_HOUR) d.setDate(d.getDate() - 1);
  d.setHours(12, 0, 0, 0);
  return d;
}
export function todayKey() { return dateKey(workoutToday()); }
export function toMonIndex(date) { return (date.getDay() + 6) % 7; }
export function parseAnchor(value) {
  if (!value) return null;
  const d = new Date(`${value}T12:00:00`);
  return isNaN(d.getTime()) ? null : d;
}
export function defaultCycleAnchor() {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() - toMonIndex(d));
  return dateKey(d);
}
export function cycleIndexForDate(date, cycleLength, anchorKey) {
  const anchor = parseAnchor(anchorKey) || parseAnchor(defaultCycleAnchor());
  const d = new Date(date); d.setHours(12, 0, 0, 0);
  const days = Math.round((d - anchor) / 86400000);
  const len = Math.max(cycleLength, 1);
  return ((days % len) + len) % len;
}

export function createExercise(name, sets = 3, reps = 10, note = '') {
  return { id: uid('exercise'), name, sets, reps, note };
}

export function createDefaultPlan() {
  return [
    { id: uid('day'), name: 'Push A', type: 'push', focus: 'Chest & Triceps (Strength)', isRest: false, exercises: [
      createExercise('Flat Barbell Bench Press', 4, 5),
      createExercise('Incline Dumbbell Press', 3, 8),
      createExercise('Assisted Chest Dip', 3, 10),
      createExercise('Tricep Pushdown (cable)', 3, 10),
      createExercise('Overhead Tricep Extension', 3, 12),
      createExercise('Lateral Raises', 3, 15),
    ]},
    { id: uid('day'), name: 'Pull A', type: 'pull', focus: 'Back & Biceps (Strength)', isRest: false, exercises: [
      createExercise('Barbell Row', 4, 6),
      createExercise('Lat Pulldown (wide grip)', 4, 8),
      createExercise('Chest Supported Row', 3, 10),
      createExercise('Face Pull', 3, 15),
      createExercise('Preacher Curl (machine)', 3, 10),
      createExercise('Hammer Curl', 3, 10),
    ]},
    { id: uid('day'), name: 'Legs A', type: 'legs', focus: 'Quad (Strength)', isRest: false, exercises: [
      createExercise('Smith Machine Squat', 4, 6),
      createExercise('Leg Press', 4, 10),
      createExercise('Leg Extension', 3, 12),
      createExercise('Seated Leg Curl', 3, 12),
      createExercise('Calf Raises', 4, 15),
      createExercise('Ab Crunch Machine', 3, 15),
    ]},
    { id: uid('day'), name: 'Recovery', type: 'rest', focus: 'Reset', isRest: true, exercises: [] },
    { id: uid('day'), name: 'Push B', type: 'push', focus: 'Shoulders & Chest (Volume)', isRest: false, exercises: [
      createExercise('Dumbbell Shoulder Press', 4, 10),
      createExercise('Flat Barbell Bench Press', 3, 10, '@ 45kg'),
      createExercise('Cable Fly', 3, 15),
      createExercise('JM Press', 3, 10),
      createExercise('Overhead Tricep Extension', 3, 12),
      createExercise('Lateral Raises', 4, 15),
    ]},
    { id: uid('day'), name: 'Pull B', type: 'pull', focus: 'Back & Biceps (Volume)', isRest: false, exercises: [
      createExercise('Chest Supported Row', 3, 12),
      createExercise('Lat Pulldown (wide grip)', 3, 12),
      createExercise('Straight Arm Pulldown', 3, 12),
      createExercise('Rear Delt Fly', 3, 15),
      createExercise('Preacher Curl (machine)', 3, 10),
      createExercise('Hammer Curl', 3, 10),
    ]},
    { id: uid('day'), name: 'Legs B', type: 'legs', focus: 'Hamstring (Volume)', isRest: false, exercises: [
      createExercise('Dumbbell RDL', 4, 10),
      createExercise('Seated Leg Curl', 3, 12),
      createExercise('Smith Machine Squat', 3, 10),
      createExercise('Leg Extension', 3, 15),
      createExercise('Calf Raises', 4, 15),
      createExercise('Ab Crunch Machine', 3, 15),
    ]},
    { id: uid('day'), name: 'Recovery', type: 'rest', focus: 'Reset', isRest: true, exercises: [] },
  ];
}

function createInitialState() {
  return {
    version: 2,
    profile: {
      completed: false, displayName: '', goal: 'build muscle',
      environment: 'gym', equipment: 'Full gym', trainingDays: 5,
      calorieTarget: 2800, macros: { protein: 180, carbs: 320, fats: 80 },
      hydrationTarget: 3.0, reminderTime: '18:00', note: '',
    },
    plan: createDefaultPlan(),
    cycleAnchor: defaultCycleAnchor(),
    logs: {}, nutrition: {}, dailyNotes: {}, recovery: {}, bodyMetrics: [], progressPhotos: [],
    swaps: {}, setCounts: {}, customExercises: [], foods: [], mealTemplates: [],
    // Daily supplements. Creatine is seeded because "did I take it today?" is
    // the question people actually have; anything else is user-added.
    supplements: { items: [{ id: 'supp-creatine', name: 'Creatine' }], log: {} },
    reminders: { enabled: false, permission: 'default', lastSentDate: '' },
    // See docs/fitness-data-model.md for the shapes of these.
    sessions: {}, measurements: [], exerciseMeta: {}, exerciseAliases: {},
    logStatus: {}, programs: [], prescriptions: {}, deloads: [],
  };
}

/* Optional plan-exercise fields (docs/fitness-data-model.md). hydrateState
 * rebuilds every plan exercise from a whitelist, so a field missing here is
 * silently dropped on the next save. */
const isPosNum = v => typeof v === 'number' && Number.isFinite(v) && v > 0;
function exerciseExtras(ex) {
  const out = {};
  if (isPosNum(ex.repMin)) out.repMin = ex.repMin;
  if (isPosNum(ex.repMax)) out.repMax = ex.repMax;
  if (isPosNum(ex.increment)) out.increment = ex.increment;
  if (isPosNum(ex.restSec)) out.restSec = ex.restSec;
  if (Array.isArray(ex.alts)) out.alts = ex.alts.filter(n => typeof n === 'string' && n.trim()).slice(0, 3);
  if (typeof ex.setup === 'string' && ex.setup) out.setup = ex.setup;
  if (['double', 'linear', 'manual'].includes(ex.progression)) out.progression = ex.progression;
  return out;
}
const objOr = (v, fallback) => (v && typeof v === 'object' && !Array.isArray(v) ? v : fallback);

export function hydrateState(input) {
  const initial = createInitialState();
  if (!input || typeof input !== 'object') return initial;
  // The rest timer left the synced blob (it is device-local now); drop the
  // copy old saves and old server data still carry.
  const { restTimer, ...saved } = input;
  return {
    ...initial,
    ...saved,
    profile: {
      ...initial.profile,
      ...(saved.profile || {}),
      macros: { ...initial.profile.macros, ...((saved.profile && saved.profile.macros) || {}) },
    },
    plan: Array.isArray(saved.plan) && saved.plan.length >= 2
      ? saved.plan.map((day, index) => ({
          ...(initial.plan[index] || { id: uid('day'), name: 'Custom', type: 'push', focus: '', isRest: false, exercises: [] }),
          ...day,
          exercises: Array.isArray(day.exercises)
            ? day.exercises.map(ex => ({
                id: ex.id || uid('exercise'), name: ex.name || 'Custom Exercise',
                sets: Number(ex.sets || 3), reps: Number(ex.reps || 10), note: ex.note || '',
                ...exerciseExtras(ex),
              }))
            : (initial.plan[index]?.exercises || []),
        }))
      : initial.plan,
    cycleAnchor: typeof saved.cycleAnchor === 'string' && saved.cycleAnchor ? saved.cycleAnchor : initial.cycleAnchor,
    logs: saved.logs && typeof saved.logs === 'object' ? saved.logs : initial.logs,
    swaps: saved.swaps && typeof saved.swaps === 'object' ? saved.swaps : initial.swaps,
    setCounts: saved.setCounts && typeof saved.setCounts === 'object' ? saved.setCounts : initial.setCounts,
    nutrition: saved.nutrition && typeof saved.nutrition === 'object' ? saved.nutrition : initial.nutrition,
    dailyNotes: saved.dailyNotes && typeof saved.dailyNotes === 'object' ? saved.dailyNotes : initial.dailyNotes,
    customExercises: Array.isArray(saved.customExercises)
      ? saved.customExercises.filter(n => typeof n === 'string' && n.trim())
      : initial.customExercises,
    foods: Array.isArray(saved.foods) ? saved.foods : initial.foods,
    mealTemplates: Array.isArray(saved.mealTemplates) ? saved.mealTemplates : initial.mealTemplates,
    supplements: {
      items: Array.isArray(saved.supplements?.items) ? saved.supplements.items : initial.supplements.items,
      log: saved.supplements?.log && typeof saved.supplements.log === 'object' ? saved.supplements.log : {},
    },
    recovery: saved.recovery && typeof saved.recovery === 'object' ? saved.recovery : initial.recovery,
    bodyMetrics: Array.isArray(saved.bodyMetrics) ? saved.bodyMetrics : initial.bodyMetrics,
    progressPhotos: Array.isArray(saved.progressPhotos) ? saved.progressPhotos : initial.progressPhotos,
    reminders: { ...initial.reminders, ...(saved.reminders || {}) },
    sessions: objOr(saved.sessions, initial.sessions),
    measurements: Array.isArray(saved.measurements) ? saved.measurements : initial.measurements,
    exerciseMeta: objOr(saved.exerciseMeta, initial.exerciseMeta),
    exerciseAliases: objOr(saved.exerciseAliases, initial.exerciseAliases),
    logStatus: objOr(saved.logStatus, initial.logStatus),
    programs: Array.isArray(saved.programs) ? saved.programs : initial.programs,
    prescriptions: objOr(saved.prescriptions, initial.prescriptions),
  };
}

export function loadFitnessState() {
  try {
    const saved = localStorage.getItem(FITNESS_STORE);
    if (saved) return hydrateState(JSON.parse(saved));
  } catch {}
  try {
    const legacy = localStorage.getItem(LEGACY_STORE);
    if (legacy) {
      const raw = JSON.parse(legacy);
      if (raw && typeof raw === 'object') {
        return { ...createInitialState(), logs: raw.logs && typeof raw.logs === 'object' ? raw.logs : raw };
      }
    }
  } catch {}
  return createInitialState();
}

export function saveFitnessState(state) {
  try { localStorage.setItem(FITNESS_STORE, JSON.stringify(state)); } catch {}
}

/* True when a state holds real user content (not a fresh starter state). Used
 * to stop an empty/default state on one device from overwriting real data on
 * the server (and thus on other devices). */
export function hasMeaningfulData(s) {
  if (!s || typeof s !== 'object') return false;
  const nonEmptyObj = (o) => o && typeof o === 'object' && Object.keys(o).length > 0;
  const nonEmptyArr = (a) => Array.isArray(a) && a.length > 0;
  return !!(
    nonEmptyObj(s.logs) ||
    nonEmptyObj(s.nutrition) ||
    nonEmptyObj(s.dailyNotes) ||
    nonEmptyObj(s.swaps) ||
    nonEmptyObj(s.setCounts) ||
    nonEmptyArr(s.foods) ||
    nonEmptyArr(s.mealTemplates) ||
    nonEmptyObj(s.supplements?.log) ||
    nonEmptyArr(s.customExercises) ||
    nonEmptyArr(s.bodyMetrics) ||
    nonEmptyObj(s.sessions) ||
    nonEmptyObj(s.recovery) ||
    nonEmptyArr(s.measurements) ||
    nonEmptyArr(s.programs) ||
    nonEmptyObj(s.prescriptions) ||
    (s.profile && s.profile.completed)
  );
}
